/**
 * Centralized query keys for Opportunities feature
 * All files in this feature should import and use these constants
 * instead of hardcoding query key strings.
 */

export const OPPORTUNITY_NOTES_QUERY_KEY = 'opportunityNotes';
export const OPPORTUNITY_QUERY_KEY = 'opportunity';
/** Organization-scoped opportunities list (string value unchanged for cache compatibility) */
export const ORGANIZATION_OPPORTUNITIES_LIST_QUERY_KEY = 'opportunities';
export const STAFF_OPPORTUNITIES_LIST_QUERY_KEY = 'staff-opportunities-list';
export const OPPORTUNITY_STATUS_HISTORY_QUERY_KEY = 'opportunityStatusHistory';
export const OPPORTUNITY_CHANGE_HISTORY_QUERY_KEY = 'opportunityChangeHistory';

/**
 * Query key for active opportunities list (used in connection dialogs)
 * This should be invalidated when opportunities are created or updated
 */
export const getActiveOpportunitiesQueryKey = () =>
  [ORGANIZATION_OPPORTUNITIES_LIST_QUERY_KEY, 'active'] as const;
